const clientsData = [
    'assets/images/our-clients/client1.png',
    'assets/images/our-clients/client2.png',
    'assets/images/our-clients/client3.png',
    'assets/images/our-clients/client4.png',
    'assets/images/our-clients/client5.png',
    'assets/images/our-clients/client6.png',
];

export default clientsData;